// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__2r_40","header":"MessagesList_header__2NmD1","chat":"MessagesList_chat__8IjdU"};